<template>
    <span :class="textClass">
        {{ displayText }}
    </span>
</template>

<script>
export default {
    name: "OrderNumberCell",
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        displayText() {
            if (this.row.OrderNumber) {
                return this.row.OrderNumber;
            }

            if (this.row.FuelTransactionType === 0) {
                return "Doğrudan Çıkış";
            }

            return "Mevcut Değil";
        },

        textClass() {
            return !this.row.OrderNumber ? "text-muted small" : "";
        },
    },
};
</script>
